module.exports = __webpack_public_path__ + "static/media/svgskilt_turstart-1.a2290c2d.svg";